module.exports = __webpack_public_path__ + "img/ab_icon-1.419033f4.svg";